import { NavLink, useLocation } from "react-router-dom";
import "../Sidenavbar.css";
import Logo from "../assets/logo.png";
import { useState } from "react";

export default function Sidenav({ collapsed, mobileOpen, onExpand }) {

    const userData = JSON.parse(localStorage.getItem("user"));
    const [openMenus, setOpenMenus] = useState({});
    const location = useLocation();
    const role = userData?.role;

    // ADMIN MENU
    const adminNavItems = [
        {
            items: [
                {
                    icon: "bi-house-door-fill",
                    label: "Home",
                    path: "/admin/home"
                },

                // {
                //     icon: "bi-trophy-fill",
                //     label: "Lottery Details",
                //     path: "/admin/lotterydetails"
                // },

                // user-- > 

                {
                    icon: "bi-kanban-fill",
                    label: "Projects",
                    path: "/admin/projects"
                },
                {
                    icon: "bi-people-fill",
                    label: "Users",
                    submenu: [
                        { icon: "bi-list-ul", label: "Users", path: "/admin/users" },
                        { icon: "bi-wallet2", label: "Wallet Details", path: "/admin/wallet" },
                        { icon: "bi-person-check-fill", label: "Active Users", path: "/admin/activeusers" },

                    ]
                },

                // fund -- > 

                {
                    icon: "bi-cash-coin",
                    label: "Fund Management",
                    submenu: [


                        { icon: "bi-hourglass-split", label: "Pending Fund Request", path: "/admin/widthraw-request" },

                        { icon: "bi-patch-check-fill", label: "Approved Fund Request", path: "/admin/approved-request" },

                        { icon: "bi-arrow-left-right", label: "Rejected Fund Request", path: "/admin/rejected-request" },



                    ]
                },

                {
                    icon: "bi-gift-fill",
                    label: "Lucky Draw",
                    path: "/admin/lucky-draw"
                },

                {
                    icon: "bi-collection-fill",
                    label: "Gallery",
                    path: "/admin/gallery"
                },

                {
                    icon: "bi-bank",
                    label: "Bank Account Approval",
                    path: "/admin/bank-account-approval"
                },

                {
                    icon: "bi-card-list",
                    label: "Reports",
                    submenu: [
                        {
                            icon: "bi-graph-up-arrow",
                            label: "Total Income Report",
                            path: "/admin/totalincomereport"
                        },
                    ]
                },



            ],
        },
    ];

    // USER MENU
    const userNavItems = [
        {
            items: [
                {
                    icon: "bi-house-door-fill",
                    label: "Home",
                    path: "/user/home"
                },
                {
                    icon: "bi-gift-fill",
                    label: "Luckydraw",
                    path: "/user/userluckydraw"
                },


                // Team Menu
                {
                    icon: "bi-people-fill",
                    label: "My Team",
                    path: "/user/myteam"
                },
                {
                    icon: "bi-check-circle-fill",
                    label: "Wallet",
                    path: "/user/wallet"
                },
                {
                    icon: "bi-currency-rupee",
                    label: "Withdraw",
                    path: "/user/withdraw",
                },


                // Report --- > 
                {
                    icon: "bi-bank",
                    label: "Bank Account",
                    path: "/user/bankaccount"
                },
                {
                    icon: "bi-headset",
                    label: "Support",
                    path: "/user/support"
                },

            ],
        },
    ];

    const toggleSubmenu = (label) => {
        setOpenMenus((prev) => ({
            ...prev,
            [label]: !prev[label],
        }));
    };


    const isSubmenuActive = (submenu) => {
        if (!submenu) return false;
        return submenu.some((sub) => location.pathname === sub.path);
    };


    const handleCollapsedSubmenuClick = (label) => {
        if (collapsed && onExpand) {
            onExpand();
            setTimeout(() => {
                setOpenMenus((prev) => ({ ...prev, [label]: true }));
            }, 100);
        } else {
            toggleSubmenu(label);
        }
    };

    const navItems = role === "admin" ? adminNavItems : userNavItems;

    return (
        <div
            className={`sar-sidebar${collapsed ? " collapsed" : ""}${mobileOpen ? " mobile-open" : ""}`}
        >
            {/* LOGO */}
            <div className="sidebar-logo">
                <div
                    className={`logo-wrapper${collapsed ? " logo-wrapper--collapsed" : ""}`}
                    style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                    <img src={Logo} alt="SarServices Logo" className="logo-full" />
                    {!collapsed && (
                        <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.1" }}>
                            <span style={{ color: "#07d7f3", fontSize: "20px", fontWeight: "700", letterSpacing: "0.5px" }}>
                                Cash Back
                            </span>
                            <span style={{ color: "#ffffff", fontSize: "11px", fontWeight: "500", opacity: 0.9, letterSpacing: "1px", textTransform: "uppercase" }}>
                                Promotors & Developer
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {/* Navigation */}
            <div className="nav-scroll">
                {navItems.map((section, si) => (
                    <div key={si}>
                        {si > 0 && <div className="nav-sep" />}

                        {section.items.map((item) => {
                            const hasSubmenu = item.submenu && item.submenu.length > 0;
                            const submenuActive = hasSubmenu && isSubmenuActive(item.submenu);
                            const menuOpen = openMenus[item.label];

                            return (
                                <div className="nav-item-wrapper" key={item.label}

                                    onMouseEnter={(e) => {
                                        const tooltip = e.currentTarget.querySelector('.nav-tooltip');
                                        if (tooltip) {
                                            const rect = e.currentTarget.getBoundingClientRect();
                                            tooltip.style.top = (rect.top + rect.height / 2) + 'px';
                                        }
                                    }}

                                >


                                    {!hasSubmenu ? (
                                        <NavLink
                                            to={item.path}
                                            className={({ isActive }) =>
                                                `nav-link-custom${isActive ? " active-nav" : ""}`
                                            }
                                        >
                                            <span className="nav-icon">
                                                <i className={`bi ${item.icon}`} />
                                            </span>
                                            <span className="nav-label">{item.label}</span>
                                        </NavLink>
                                    ) : (

                                        <div
                                            className={`nav-link-custom submenu-parent${submenuActive || menuOpen ? " active-nav" : ""}`}
                                            onClick={() => handleCollapsedSubmenuClick(item.label)}
                                        >
                                            <div className="submenu-left">
                                                <span className="nav-icon" style={{ position: "relative" }}>
                                                    <i className={`bi ${item.icon}`} />

                                                    {collapsed && submenuActive && (
                                                        <span className="submenu-active-badge" />
                                                    )}
                                                </span>
                                                <span className="nav-label">{item.label}</span>
                                            </div>
                                            {!collapsed && (
                                                <span className="submenu-arrow">
                                                    <i className={`bi ${menuOpen ? "bi-chevron-down" : "bi-chevron-right"}`} />
                                                </span>
                                            )}
                                        </div>
                                    )}


                                    {collapsed && (
                                        <div className="nav-tooltip">
                                            <div className="tooltip-title">{item.label}</div>
                                            {hasSubmenu && (
                                                <div className="tooltip-submenu-list">
                                                    {item.submenu.map((sub) => (
                                                        <NavLink
                                                            key={sub.label}
                                                            to={sub.path}
                                                            className={({ isActive }) =>
                                                                `tooltip-sub-link${isActive ? " tooltip-sub-active" : ""}`
                                                            }
                                                        >
                                                            {sub.label}
                                                        </NavLink>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}


                                    {hasSubmenu && menuOpen && !collapsed && (
                                        <div className="submenu-wrapper">
                                            {item.submenu.map((subItem) => (
                                                <NavLink
                                                    key={subItem.label}
                                                    to={subItem.path}
                                                    className={({ isActive }) =>
                                                        `submenu-link${isActive ? " active-submenu" : ""}`
                                                    }
                                                >
                                                    <span className="submenu-icon">
                                                        <i className={`bi ${subItem.icon}`} />
                                                    </span>
                                                    <span>{subItem.label}</span>
                                                </NavLink>
                                            ))}
                                        </div>
                                    )}

                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>

            {/* footer ----- > */}
            <div className="sidebar-footer">
                <div className="user-card">
                    <div className="user-avatar">
                        {userData?.user?.name?.slice(0, 1)?.toUpperCase() || "US"}
                    </div>
                    {!collapsed && (
                        <>
                            <div className="user-info">

                                <div className="user-name">
                                    {userData?.user?.name}
                                </div>



                            </div >


                        </>
                    )
                    }
                </div >
            </div >
        </div >
    );
}